import { MultiCheckboxFilterOption } from '../types';
import { MultiSelectCheckbox } from '../../components';

export const config: MultiCheckboxFilterOption = {
  id: 'omicsExplorer.filters.structuralVariant.type',
  title: {
    id: 'omicsExplorer.filters.structuralVariant.type',
    defaultMessage: 'Effect',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'type',
    checkboxOptions: [
      {
        id: 'omicsExplorer.filters.structuralVariant.type.deletion',
        searchValue: 'deletion',
        intlLabel: {
          id: 'omicsExplorer.filters.structuralVariant.type.deletion',
          defaultMessage: 'Deletion',
        },
      },
      {
        id: 'omicsExplorer.filters.structuralVariant.type.duplication',
        searchValue: 'duplication',
        intlLabel: {
          id: 'omicsExplorer.filters.structuralVariant.type.duplication',
          defaultMessage: 'Duplication',
        },
      },
      {
        id: 'omicsExplorer.filters.structuralVariant.type.fusion',
        searchValue:
          'fusion,Fusion,near fusion,rna_fusion_transcript,rna_fusion',
        intlLabel: {
          id: 'omicsExplorer.filters.structuralVariant.type.fusion',
          defaultMessage: 'Fusion',
        },
      },
      {
        id: 'omicsExplorer.filters.structuralVariant.type.interruption',
        searchValue: 'interruption',
        intlLabel: {
          id: 'omicsExplorer.filters.structuralVariant.type.interruption',
          defaultMessage: 'Interruption',
        },
      },
      {
        id: 'omicsExplorer.filters.structuralVariant.type.rearrangement',
        searchValue: 'rearrangement',
        intlLabel: {
          id: 'omicsExplorer.filters.structuralVariant.type.rearrangement',
          defaultMessage: 'Rearrangement',
        },
      },
      {
        id: 'omicsExplorer.filters.structuralVariant.type.translocation',
        searchValue: 'translocation',
        intlLabel: {
          id: 'omicsExplorer.filters.structuralVariant.type.translocation',
          defaultMessage: 'Translocation',
        },
      },
      {
        id: 'omicsExplorer.filters.structuralVariant.type.truncation',
        searchValue: 'truncation',
        intlLabel: {
          id: 'omicsExplorer.filters.structuralVariant.type.truncation',
          defaultMessage: 'Truncation',
        },
      },
      {
        id: 'omicsExplorer.filters.structuralVariant.type.withinIntron',
        searchValue: 'within intron',
        intlLabel: {
          id: 'omicsExplorer.filters.structuralVariant.type.withinIntron',
          defaultMessage: 'Within Intron',
        },
      },
      {
        id: 'omicsExplorer.filters.structuralVariant.type.insertion',
        searchValue: 'insertion',
        intlLabel: {
          id: 'omicsExplorer.filters.structuralVariant.type.insertion',
          defaultMessage: 'Insertion',
        },
      },
    ],
  },
};
